import { render, staticRenderFns } from "./IpFirewallFormBody.vue?vue&type=template&id=2d7be8aa&scoped=true"
import script from "./IpFirewallFormBody.vue?vue&type=script&lang=js"
export * from "./IpFirewallFormBody.vue?vue&type=script&lang=js"
import style0 from "./IpFirewallFormBody.vue?vue&type=style&index=0&id=2d7be8aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7be8aa",
  null
  
)

export default component.exports